import { createFileRoute } from '@tanstack/react-router'
import MatchesPage from '@/pages/matches/matches-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/matches',
)({
  component: function MatchesRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <RequireModule module={MODULES.MATCHES} dashboardId={dashboardId}>
        <ProtectedRoute
          anyOf={[CAPABILITIES.LEADS_ALL, CAPABILITIES.LEADS_OWN]}
          dashboardId={dashboardId}
        >
          <MatchesPage dashboardId={dashboardId} />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
